import request from '@/utils/request'

let WaybillApi = {

  /*货运单列表*/
  list(data) {
    return request._post('/shop/plus.waybill.Index/index', data);
},
/*添加货运单*/
add(data) {
    return request._post('/shop/plus.waybill.Index/add', data);
},
/*修改货运单*/
edit(data) {
    return request._post('/shop/plus.waybill.Index/edit', data);
},
/*删除货运单*/
del(data) {
    return request._post('/shop/plus.waybill.Index/del', data);
},
/*货运单详情*/
detail(data) {
  return request._post('/shop/plus.waybill.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.waybill.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.waybill.Setting/getSetting', data, errorback);
    },
}
export default WaybillApi;



// WEBPACK FOOTER //
// ./src/api/waybill.js